import { api } from '@/lib/api';
import type {
  AgentWebhookLogResponse,
  AgentWebhookLogStats,
  ApiResponse,
  PaginatedResponse,
} from '@troia-v3/types';

/**
 * Agent Webhook Logs API Service
 */
export const agentWebhookLogsApi = {
  /**
   * Get logs for a webhook, paginated
   */
  async getLogs(webhookId: string, query?: { page?: number; limit?: number }): Promise<PaginatedResponse<AgentWebhookLogResponse>> {
    const response = await api.get('agent-webhook-logs', {
      params: { webhookId, ...query },
    });
    return response.data;
  },

  /**
   * Get execution stats for a webhook
   */
  async getStats(webhookId: string): Promise<ApiResponse<AgentWebhookLogStats>> {
    const response = await api.get(`agent-webhook-logs/${webhookId}/stats`);
    return response.data;
  },
};
